/** Message catalogue for features/catalog/ops (merged into the global catalogues). Keys: "ops.<area>.<name>". */
import { batchMessages } from './messages.batch';
import { inventoryMessages } from './messages.inventory';
import { designerMessages } from './messages.designer';
import { sharedMessages } from './messages.shared';

const pairs = { ...sharedMessages, ...batchMessages, ...designerMessages, ...inventoryMessages };
type Key = keyof typeof pairs;

const keys = Object.keys(pairs) as Key[];

export const opsEn = Object.fromEntries(keys.map((k) => [k, pairs[k][0]])) as { [K in Key]: string };

export const opsHi: Record<keyof typeof opsEn, string> = Object.fromEntries(keys.map((k) => [k, pairs[k][1]])) as { [K in Key]: string };
